import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { type IDV2Store, StoreContext } from './idv2-provider';
import { useNavigation } from './use-navigation';
export const useIdv2 = () => {
  const $ = _c(8);
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useIdv2 must be used within Idv2Provider");
  }
  const selector = useShallow(_temp);
  const {
    allRequirements,
    relayToIDV2,
    canGoBack,
    onHandoffComplete
  } = useStore(store, selector);
  const navigation = useNavigation();
  let t0;
  if ($[0] !== allRequirements || $[1] !== canGoBack || $[2] !== relayToIDV2) {
    t0 = {
      allRequirements,
      canGoBack,
      relayToIDV2
    };
    $[0] = allRequirements;
    $[1] = canGoBack;
    $[2] = relayToIDV2;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== navigation || $[5] !== onHandoffComplete || $[6] !== t0) {
    t1 = {
      data: t0,
      navigation,
      onHandoffComplete
    };
    $[4] = navigation;
    $[5] = onHandoffComplete;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
function _temp(state) {
  return {
    allRequirements: state.data.allRequirements,
    relayToIDV2: state.data.relayToIDV2,
    canGoBack: state.data.canGoBack,
    onHandoffComplete: state.onHandoffComplete
  };
}